var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { FreeButton } from '../..';
import './ConfirmButton.css';
export default function ConfirmButton(props) {
    var _a = useState(false), expanded = _a[0], setExpanded = _a[1];
    function clickHandler(e) {
        if (expanded) {
            if (props.onClick) {
                props.onClick(e);
            }
            setExpanded(false);
            if (props.onCollapse) {
                props.onCollapse();
            }
        }
        else {
            e.stopPropagation();
            setExpanded(true);
            if (props.onExpand) {
                props.onExpand(e);
            }
            e.stopPropagation();
        }
    }
    function blurHandler() {
        setExpanded(false);
        if (props.onCollapse) {
            props.onCollapse();
        }
    }
    var expandedClass = expanded ? ' expanded ' : '';
    return (_jsx(FreeButton, __assign({ className: props.className + ' ConfirmButton ' + expandedClass + 'button', title: props.title, disabled: props.disabled, hidden: props.hidden, onClick: clickHandler, style: expanded ? __assign(__assign({}, props.style), props.expandedStyle) : props.style, onBlur: blurHandler, loading: props.loading }, { children: expanded ? props.expandedContent : props.content }), void 0));
}
//# sourceMappingURL=ConfirmButton.js.map